import Hangfire from './hangfire-view'
export default Hangfire
